import styled from 'styled-components'

const Base = styled.div({
  minWidth: 320,
  padding: '0 20px',

  // to create new block formatting context
  overflow: 'auto',
})

export { Base }
